import { render, staticRenderFns } from "./Importa.vue?vue&type=template&id=6083f5fa&scoped=true"
import script from "./Importa.vue?vue&type=script&lang=js"
export * from "./Importa.vue?vue&type=script&lang=js"
import style0 from "./Importa.vue?vue&type=style&index=0&id=6083f5fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6083f5fa",
  null
  
)

export default component.exports